import React, { useState, useMemo } from "react";
import { newsletterSubmission } from "../Transformations/FormData";
import { Alert, Box, Button, Modal, Typography } from "@mui/material";

export default function NewsLetterForm() {
	// Control modal visibility
	const [open, setOpen] = useState(false);
	const toggleModal = () => setOpen(!open);

	// Memoize the modal style
	const style = useMemo(
		() => ({
			position: "absolute",
			boxShadow:
				"0.2rem 0.2rem 0.2rem #edf7ed, 0.2rem -0.2rem 0.2rem #edf7ed, -0.2rem 0.2rem 0.2rem #edf7ed, -0.2rem -0.2rem 0.2rem #edf7ed",
			top: "50%",
			left: "50%",
			transform: "translate(-50%, -50%)",
			width: 400,
			bgcolor: "background.paper",
		}),
		[]
	);

	const handleSubmit = async (event) => {
		event.preventDefault();
		const formData = new FormData(event.target);
		const formDataObject = Object.fromEntries(formData);
		// console.log("form", formDataObject);
		const emailStatus = await newsletterSubmission(formDataObject);

		if (emailStatus.status === "mail_sent") {
			toggleModal();
		}

		// Reset the form after submission
		event.target.reset();
	};

	return (
		<div className="newsletter-sec">
			<h3>Newsletter</h3>
			<form name="newsletter-form" onSubmit={handleSubmit} id="newsletter-form">
				<div className="form-field">
					<label className="form-label">
						Name <span className="required">*</span>
					</label>
					<input
						name="name"
						type="text"
						className="form-input"
						placeholder="Ihr Name"
						autoComplete="on"
						required
					/>
				</div>

				<div className="form-field">
					<label className="form-label">
						Email <span className="required">*</span>
					</label>
					<input
						name="email"
						type="email"
						className="form-input"
						placeholder="Ihre Email-Adresse"
						required
					/>
				</div>

				<div className="form-checkbox">
					<div className="form-field">
						<div className="form-label">
							<label className="inline"></label>
						</div>
						<div className="form-data">
							<div className="form-checkbox-wrapper">
								<input
									name="unternehmensnachfolge"
									type="checkbox"
									id="unternehmensnachfolge"
									className=" "
								/>
								<label htmlFor="unternehmensnachfolge" className="inline">
									Unternehmensnachfolge
								</label>
							</div>
						</div>
					</div>

					<div className="form-field">
						<div className="form-label">
							<label className="inline"></label>
						</div>
						<div className="form-data">
							<div className="form-checkbox-wrapper">
								<input
									name="immobilienmanagementunternehmen"
									type="checkbox"
									id="immobilienmanagementunternehmen"
									className=" "
								/>
								<label
									htmlFor="immobilienmanagementunternehmen"
									className="inline"
								>
									Immobilienmanagement-Unternehmen
								</label>
							</div>
						</div>
					</div>
				</div>
				<div className="form-field">
					<button
						aria-label="submit-btn"
						type="submit"
						className="button-form py-1"
					>
						Newsletter abonnieren
					</button>
				</div>
			</form>

			<Modal open={open} onClose={toggleModal}>
				<Box sx={style}>
					<Typography variant="h6">
						<Alert severity="success">
							<p className="text-center">
								Vielen Dank für Ihre Newsletter-Registrierung.
							</p>
						</Alert>
					</Typography>
				</Box>
			</Modal>
		</div>
	);
}
